// src/store/actions/festival.actions.ts
import { createActionGroup, props } from '@ngrx/store';
import { FestivalTheme } from '../../core/festival/festival.config';

export const FestivalActions = createActionGroup({
  source: 'Festival',
  events: {
    // Triggered from service.init() → Effect picks it up
    'Load Festival Theme': props<{ status: string; countryCode: string }>(),

    // Effect dispatches these after API call
    'Load Festival Theme Success': props<{ festivals: FestivalTheme[]; activeFestival: FestivalTheme | null }>(),
    'Load Festival Theme Failure': props<{ error: string }>(),

    // User dismisses the banner
    'Dismiss Festival Banner': props<{ themeKey: string }>(),

    // Manual override (admin/testing)
    'Set Active Festival': props<{ festival: FestivalTheme | null }>(),

    // Clear everything
    'Clear Festival Theme': props<Record<string, never>>(),
  },
});